import { useContext } from 'react';
import { LogOut } from 'lucide-react';
import AuthContext from '../../store/auth-context';
import { Button } from '../ui/button';

interface LogoutButtonProps {
    className?: string;
}

export default function LogoutButton({ className }: LogoutButtonProps) {
    const authContext = useContext(AuthContext);

    return (
        <Button
            variant="outline"
            size="sm"
            className={className}
            onClick={authContext.onLogout}
        >
            <LogOut className="h-3.5 w-3.5" aria-hidden="true" />
            Log out
        </Button>
    );
}
